export { useWallet as useCustomWallet } from "./WalletProvider";
